import { render } from "./dealerPage.vue?vue&type=template&id=106e740b"
import script from "./dealerPage.vue?vue&type=script&lang=js"
export * from "./dealerPage.vue?vue&type=script&lang=js"

import "./dealerPage.vue?vue&type=style&index=0&id=106e740b&lang=scss"
import "./dealerPage.vue?vue&type=style&index=1&id=106e740b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__